const errorStrings = {
  duplicateLabel: (label) =>
    `A field with the Label ${label} already exists, Labels must be unique`,
  duplicateKey: (label, key) =>
    `The "${label}" field is already using the key ${key}.  Keys must be unique`,
  INVALID_DEFAULT: `Invalid default value`,
  INVALID_KEY:
    'Key can only contain numbers or lower case letters, and must be in this format: this_is_a_valid_key',
  MISSING_KEY: `A Key is required for this field`,
  MISSING_LABEL: `A Label is required for this field`,
  MISSING_TYPE: `A Type is required for this field`,
  INVALID_MULTI_OPTIONS:
    'The multiple options field is required before saving the custom field',
  INVALID_MULTI_OPTIONS_LABEL:
    'In order to save the multiple options custom field you must provide a label for each of the values',
  INVALID_SELECT_OPTIONS:
    'The single choice field is required before saving the custom field',
  INVALID_SELECT_OPTIONS_LABEL:
    'In order to save the single choice custom field you must provide a label for each of the values',
};

export { errorStrings };
